import React from 'react';

export const GenerateSpendCubeContext = React.createContext({});
